import { rankList } from "@/mocks/comics";

const maxHeat = Math.max(...rankList.map((r) => r.heat));

export default function RankBoard() {
  return (
    <section id="rank" className="scroll-mt-28 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
              <i className="ri-bar-chart-2-line text-sm" aria-hidden="true"></i>
              本周人气榜
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">大家都在追的十部作品</h2>
            <p className="mt-2 max-w-[620px] text-sm leading-relaxed text-foreground-600">
              榜单根据近七天的阅读、收藏与下载行为综合排序，每周一更新。新作上榜说明它在更新节奏或剧情节点上
              正被大量读者同时关注。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-calendar-line text-sm" aria-hidden="true"></i>
            统计周期：近 7 天
          </span>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 lg:grid-cols-[1.55fr_1fr]">
          <ol className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {rankList.map((item, idx) => (
              <li
                key={item.rank}
                className={`flex items-center gap-3 px-4 py-3 ${
                  idx !== rankList.length - 1 ? "border-b border-background-200" : ""
                } ${item.rank <= 3 ? "bg-accent-50/60" : ""}`}
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm ${
                    item.rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate font-heading text-sm text-foreground-950 md:text-base">{item.title}</h3>
                    <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {item.genre}
                    </span>
                  </div>
                  <p className="mt-0.5 truncate text-xs text-foreground-500">{item.note}</p>
                </div>
                <div className="hidden w-40 shrink-0 sm:block">
                  <div className="h-1.5 overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-primary-500"
                      style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                    ></div>
                  </div>
                </div>
                <span className="w-16 shrink-0 text-right text-xs text-foreground-600">{item.heat} 万</span>
              </li>
            ))}
          </ol>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-background-200 bg-foreground-950 p-5 text-background-50">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/20 px-3 py-1 text-xs text-accent-300">
                <i className="ri-medal-line text-sm" aria-hidden="true"></i>
                榜首作品
              </span>
              <h3 className="mt-3 font-heading text-xl">{rankList[0].title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100/85">
                东方玄幻长篇，本周依旧占据讨论热度第一。214 话的决战前夜把主线冲突推到顶点，也让「找回记忆」
                这条线索第一次和旧城之谜合并。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                <a
                  href="#latest"
                  className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap"
                >
                  <i className="ri-play-circle-line text-base" aria-hidden="true"></i>
                  从最新话看起
                </a>
                <a
                  href="#completed"
                  className="inline-flex items-center gap-1.5 rounded-md border border-background-50/25 px-4 py-2 text-sm text-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap"
                >
                  <i className="ri-download-2-line text-base" aria-hidden="true"></i>
                  有完结作品吗
                </a>
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base text-foreground-950">
                <i className="ri-arrow-up-circle-line text-secondary-600" aria-hidden="true"></i>
                本榜上升最快
              </h3>
              <ul className="mt-3 space-y-2.5">
                {rankList.slice(4, 7).map((item) => (
                  <li key={item.rank} className="flex items-center justify-between gap-3 text-sm">
                    <span className="truncate text-foreground-800">
                      <span className="mr-1 text-xs text-foreground-500">No.{item.rank}</span>
                      {item.title}
                    </span>
                    <span className="shrink-0 text-xs text-accent-700">↑ {item.heat} 万</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}